import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { copy } from './copy'

export type Lang = 'vi' | 'en'
type Ctx = { lang: Lang; setLang: (l: Lang) => void; t: (k: string) => string }

const I18nCtx = createContext<Ctx>({ lang: 'vi', setLang: () => {}, t: (k) => k })

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    try {
      const s = localStorage.getItem('argo_lang')
      if (s === 'en' || s === 'vi') return s
    } catch {}
    return 'vi'
  })
  const setLang = useCallback((l: Lang) => {
    setLangState(l)
    try { localStorage.setItem('argo_lang', l) } catch {}
    document.documentElement.lang = l
  }, [])
  const t = useCallback((k: string) => copy[k]?.[lang] ?? k, [lang])
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
}

export const useI18n = () => useContext(I18nCtx)
